import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Modal from '../../../../components/Modal'

import { ReactComponent as CloseIcon } from '../../../../assets/icons/close-grey.svg'

import useStyles from './styles'

const InfoModal = ({ Icon, isOpen, onClose, modalTitle, children, Buttons, className }) => {
  const classes = useStyles()

  const { t } = useTranslation()

  return (
    <Modal isOpen={isOpen} onRequestClose={onClose} shouldFocusAfterRender={true} className={className}>
      <span onClick={onClose} className={classes.closeIcon}>
        <CloseIcon />
      </span>
      {Icon && <Icon />}
      {modalTitle && <h3 className={classes.title}>{t(modalTitle)}</h3>}
      {children && <div className={classes.content}>{children}</div>}
      {Buttons && <div className={classes.btnContainer}>{Buttons}</div>}
    </Modal>
  )
}

InfoModal.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  modalTitle: PropTypes.string,
  Icon: PropTypes.object,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  className: PropTypes.string
}

export default InfoModal
